import * as Util from "../Utils/Util";
import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import ButtonMarker from "../Utils/ButtonMarker";
import ProductState from "./ProductState";

export default class StrengthButton {
  private readonly element: HTMLElement;
  private readonly productCode: string;
  private readonly strengthCode: string;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.productCode = Util.getData(element, "productCode");
    this.strengthCode = Util.getData(element, "strengthCode");
    element.addEventListener("click", () => this.send());
    Events.on("product-state-change", (s: ProductState) => ButtonMarker.mark(element, this.isActive(s)));
  }

  private isActive(s: ProductState): boolean {
    return s.product.code == this.productCode && s.strength.code == this.strengthCode;
  }

  private send(): void {
    Events.fire("strength-changed", this.strengthCode);
  }

  public static Factory: DomFactory<StrengthButton> = (e) => new StrengthButton(e);
}
